"use strict";
export default class Ports {
  constructor(app) {
    this.app = app;
  }
  safeSubscribe(portName, callback) {
    if (typeof this.app.ports[portName] != "undefined") {
      this.app.ports[portName].subscribe(callback);
    } else {
      console.info(`Elm port '${portName}' doesn't appear to be used and maybe should be deleted?`);
    }
  }
  safeSend(portName, value) {
    if (typeof this.app.ports[portName] != "undefined") {
      this.app.ports[portName].send(value);
    } else {
      console.info(`Elm port '${portName}' doesn't appear to be used and maybe should be deleted?`);
    }
  }
}
